import { ApiProperty } from '@nestjs/swagger';
import { IsEmail, IsString, MaxLength, MinLength } from 'class-validator';
import { Exclude } from 'class-transformer';
import {
  SUPPORT_MESSAGE_LENGTH_MAX,
  SUPPORT_MESSAGE_LENGTH_MIN,
  SUPPORT_MESSAGE_SENDER_EMAIL_LENGTH_MAX,
  SUPPORT_MESSAGE_SENDER_NAME_LENGTH_MAX,
  SUPPORT_MESSAGE_SENDER_NAME_LENGTH_MIN,
} from '../../const/support/message';
import { validatorMessageFromDictionary } from '../../utils/validation/i18n/createMessagesDictionary';
import { LanguageCode } from '../resource/language';

export class SupportSendMessageRequest {
  @ApiProperty()
  @IsString()
  @MinLength(SUPPORT_MESSAGE_SENDER_NAME_LENGTH_MIN, {
    message: ({ constraints }) =>
      validatorMessageFromDictionary({
        [LanguageCode.Russian]: `Минимальная длина имени: ${constraints[0]}`,
      }),
  })
  @MaxLength(SUPPORT_MESSAGE_SENDER_NAME_LENGTH_MAX, {
    message: ({ constraints }) =>
      validatorMessageFromDictionary({
        [LanguageCode.Russian]: `Максимальная длина имени: ${constraints[0]}`,
      }),
  })
  name: string;

  @ApiProperty()
  @IsString()
  @MaxLength(SUPPORT_MESSAGE_SENDER_EMAIL_LENGTH_MAX, {
    message: ({ constraints }) =>
      validatorMessageFromDictionary({
        [LanguageCode.Russian]: `Максимальная длина email: ${constraints[0]}`,
      }),
  })
  @IsEmail(undefined, {
    message: () =>
      validatorMessageFromDictionary({
        [LanguageCode.Russian]: 'Укажите корректный email адрес',
      }),
  })
  email: string;

  @ApiProperty()
  @IsString()
  @MinLength(SUPPORT_MESSAGE_LENGTH_MIN, {
    message: ({ constraints }) =>
      validatorMessageFromDictionary({
        [LanguageCode.Russian]: `Минимальная длина сообщения: ${constraints[0]}`,
      }),
  })
  @MaxLength(SUPPORT_MESSAGE_LENGTH_MAX, {
    message: ({ constraints }) =>
      validatorMessageFromDictionary({
        [LanguageCode.Russian]: `Максимальная длина сообщения: ${constraints[0]}`,
      }),
  })
  message: string;

  @ApiProperty()
  @Exclude()
  attachments?: unknown;
}
